
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"16","cy":"16","r":"16","fill":"#7B2CBF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.0711 8.92898C22.6805 8.53845 22.0474 8.53845 21.6569 8.92898L16 14.5858L10.3431 8.92898C9.95262 8.53845 9.31946 8.53845 8.92893 8.92898C8.53841 9.3195 8.53841 9.95267 8.92893 10.3432L14.5858 16L8.92893 21.6569C8.53841 22.0474 8.53841 22.6806 8.92893 23.0711C9.31946 23.4616 9.95262 23.4616 10.3431 23.0711L16 17.4143L21.6569 23.0711C22.0474 23.4616 22.6805 23.4616 23.0711 23.0711C23.4616 22.6806 23.4616 22.0474 23.0711 21.6569L17.4142 16L23.0711 10.3432C23.4616 9.95267 23.4616 9.3195 23.0711 8.92898Z","fill":"white"}})])
          )
        }
      }
    